// extracted by mini-css-extract-plugin
export default {"headerTabs":"styles_headerTabs__P0jhm","mainContentWrapper":"styles_mainContentWrapper__SMAPD"};